import React, { useCallback, useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Container,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import { withSwal } from 'react-sweetalert2';
import { SquarePen } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { useCompany } from "../../contexts/CompanyContext";

function Companies({ swal }) {
    const { companies, isLoading } = useCompany();
    const navigate = useNavigate();

    // Edit action for a company
    const handleEdit = (company) => {
        navigate(`/dashboard/edit-company/${company.id}`);
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                position: 'relative'
                // minHeight: "84vh",
                // background: "linear-gradient(to left, #0BD349, #000000)",
            }}
        >
            <img style={{
                width: '100%',
                objectFit: 'contain',
                position: 'fixed',
                zIndex: -1
            }} src="https://cdn.prod.website-files.com/65f03c978efea1c906592c94/65f41d5f2ba41fbbe6c5514c_AdobeStock_546815906_gruen_klein_bearbeitet_002.webp" />
            <Container>
                <Typography
                    variant="h4"
                    component="h1"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#0BD349",
                        paddingTop: "5px",
                    }}
                >
                    {/* Companies */}
                    Unternehmen
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingBottom: "16px",
                    }}
                >
                    <Link to="/dashboard/add-company">
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#fff",
                                color: "#333",
                                padding: "12px 24px",
                                fontSize: "16px",
                                borderRadius: "8px",
                                "&:hover": {
                                    backgroundColor: "#098B2B",
                                    // color: "#fff",
                                },
                                // border: '1px solid #eee',
                            }}
                        >
                            {/* Add New Company */}
                            Neues Unternehmen hinzufügen
                        </Button>
                    </Link>
                </Box>

                <TableContainer component={Paper} sx={{ marginBottom: 3, marginTop: 5, backgroundColor: 'rgb(28, 28, 28, 0.9)' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{
                                    backgroundColor: 'rgb(0, 0, 0, 0.6)',
                                    color: '#0BD349'
                                }}>
                                    {/* Company Name */}
                                    Name der Firma
                                </TableCell>
                                <TableCell style={{
                                    backgroundColor: 'rgb(0, 0, 0, 0.6)',
                                    color: '#0BD349'
                                }}>
                                    E-Mail
                                </TableCell>
                                <TableCell style={{
                                    backgroundColor: 'rgb(0, 0, 0, 0.6)',
                                    color: '#0BD349'
                                }}>
                                    {/* Profile Image */}
                                    Profilbild
                                </TableCell>
                                <TableCell style={{
                                    backgroundColor: 'rgb(0, 0, 0, 0.6)',
                                    color: '#0BD349'
                                }}>
                                    Status
                                </TableCell>
                                <TableCell style={{
                                    backgroundColor: 'rgb(0, 0, 0, 0.6)',
                                    color: '#0BD349'
                                }}>
                                    {/* Actions */}
                                    Aktionen
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                isLoading && (
                                    <TableRow>
                                        <TableCell colSpan={5}>
                                            <center>
                                                <Spin spinning={isLoading} tip="Loading" />
                                            </center>
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                            {companies.map((company) => (
                                <TableRow key={company.id}>
                                    <TableCell>{company.companyname}</TableCell>
                                    <TableCell>{company.email}</TableCell>
                                    <TableCell>
                                        <img src={company.profile_image} alt="Profile" width={50} />
                                    </TableCell>
                                    <TableCell>
                                        {
                                            company.active ? 'Active' : 'Inactive'
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <Button className="link" onClick={() => handleEdit(company)}>
                                            <SquarePen size={20} strokeWidth={1.5} />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Container>
        </Box>
    );
}

export default withSwal(({ swal }, ref) => (
    <Companies swal={swal} />
));